"use client";

import { createContext } from "react";

interface FrameConfigContextValue {
  loading: boolean;
  error: string;
  errorDebug: string;
}

const FrameConfigContext = createContext<FrameConfigContextValue>({
  loading: true,
  error: "",
  errorDebug: "",
});

export default FrameConfigContext;
